import type { ReactNode } from "react";

export default function PageHero({ eyebrow, title, text, children }: { eyebrow: string; title: ReactNode; text: string; children?: ReactNode }) {
  return (
    <section className="page-hero">
      <div className="hero-grid" />
      <div className="orb orb-one" />
      <div className="orb orb-two" />
      <div className="shell page-hero-inner">
        <div className="page-hero-copy">
          <span className="eyebrow"><i />{eyebrow}</span>
          <h1>{title}</h1>
          <p>{text}</p>
          {children}
        </div>
      </div>
    </section>
  );
}
